import { AfterViewInit, Component, Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';

import { LocService } from '../shared-context/loc.service';

import './dialog.component.css';

@Directive({
    selector: '[ohpDialogActions]'
})
export class DialogActionsDirective { }

@Directive({
    selector: '[ohpDialogFooter]'
})
export class DialogFooterDirective { }

@Component({
    selector: 'ohp-dialog',
    templateUrl: './dialog.component.html'
})
export class DialogComponent implements OnInit, AfterViewInit {

    @Input() public title: string;

    @Input() public subtitle: string;

    @Input() public content: string;

    @Input() public dismissButtonEnabled: boolean;

    @Input() public lastFocusedElementId: string;

    @Input() public componentArea: string;

    @Input() public disableCloseLinkFocus: boolean;

    @Output() public readonly dismiss: EventEmitter<void>;

    @ViewChild('closeLink') public closeLinkElement: ElementRef;

    public dismissText: string;
    public dismissAriaLabel: string;

    constructor(
        private readonly locService: LocService
    ) {
        this.dismiss = new EventEmitter<void>();
    }

    public ngOnInit() {
        this.setupFocusContext();
        this.dismissText = this.locService.Dismiss;
        this.dismissAriaLabel = this.locService.DismissDialogAriaLabel;
    }

    public ngAfterViewInit() {
        if (!this.disableCloseLinkFocus) {
            this.onWindowFocus();
        }
    }

    public onDismissClick() {
        this.dismiss.emit();
    }

    @HostListener('window:focus')
    public onWindowFocus() {
        if (this.closeLinkElement) {
            this.closeLinkElement.nativeElement.focus();
        }
    }

    private setupFocusContext() {
        if (this.lastFocusedElementId) {
            return;
        }

        if (!this.lastFocusedElementId && this.dismissButtonEnabled) {
            this.lastFocusedElementId = 'dialog-dismiss-button';
        }
    }
}
